import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type Brand = 'robuschi' | 'pedrogil';

@Injectable({ providedIn: 'root' })
export class BrandService {
  private readonly _brand$ = new BehaviorSubject<Brand>((localStorage.getItem('brand') as Brand) || 'robuschi');

  /** Observable of the current brand. Emits immediately on subscribe, then on every change. */
  readonly brand$ = this._brand$.asObservable();

  get current(): Brand {
    return this._brand$.value;
  }

  set(brand: Brand): void {
    localStorage.setItem('brand', brand);
    this._brand$.next(brand);
  }
}
